import Link from 'next/link';
import { useTranslation } from 'next-i18next';

import { useRouter } from '@boss/hooks';
import { IEvent } from '@boss/services';
import { Alert } from '@boss/ui';
import { getLocalizedSlugForEventPage, slugify } from '@boss/utils';

import { EventCardWrapper } from '../../components';
import { groupTrainingsByType } from '../../utils/trainings';

interface Props {
  events: IEvent[];
}

const TrainingsOverview = ({ events }: Props) => {
  const { t } = useTranslation(['event']);
  const { locale } = useRouter();

  const groups = groupTrainingsByType(events);

  return (
    <div className="mt-10">
      {!events.length && <Alert type="info">{t('sections.overview.noEvents', { ns: 'event' })}</Alert>}
      {groups.map(({ type, sessions }) => (
        <section className="mt-10" key={type || 'no-type'}>
          <h3 className="mb-5">
            {type ? (
              <Link className="hover:underline" href={getLocalizedSlugForEventPage(locale, `topic/${slugify(type)}`)}>
                {type}
              </Link>
            ) : (
              t('sections.overview.noType', { ns: 'event' })
            )}
          </h3>
          <div className="my-10 grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
            {sessions.map(event => (
              <EventCardWrapper event={event} key={event.id} locale={locale} />
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};

export default TrainingsOverview;
